import { render } from "./ApiSend.vue?vue&type=template&id=659ea43f&scoped=true"
import script from "./ApiSend.vue?vue&type=script&lang=js"
export * from "./ApiSend.vue?vue&type=script&lang=js"

import "./ApiSend.vue?vue&type=style&index=0&id=659ea43f&scoped=true&lang=css"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659ea43f"]])

export default __exports__